var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-layout" },
    [
      _c("navbar"),
      _vm._v(" "),
      _vm.maintenanceStatus ? _c("maintenance-banner") : _vm._e(),
      _vm._v(" "),
      _c("advisory-banner"),
      _vm._v(" "),
      _c("div", { staticClass: "container mt-4" }, [_c("child")], 1),
      _vm._v(" "),
      _c("banner"),
      _vm._v(" "),
      _c("sticky-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06bc2b2d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06bc2b2d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/layouts/default.vue
// module id = 424
// module chunks = 19